import axios from 'axios';
import { ESTADO_APROBACION_PARCIAL, ESTADO_APROBADO } from 'components/UsuarioGeneral/Vacaciones/Planificacion Vacaciones/PlanificacionVacaciones';
import Cargando from 'components/Varios/Cargando';
import React, { useEffect, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from "reactstrap";
import { authenticationService } from 'services/authentication.service';
import { PRIMER_APROBADOR, SEGUNDO_APROBADOR } from './ModalDirectivo';

//URL
import configData from "../../../config.json";
import { handle_error } from './helper_function';
import { RequestEnviarTalentoHumano } from './ModalEnviarTalentoHumano';
type Props_ModalEnviarPlanificaciones = {
    show: boolean
    toogle: () => void
    onClose: () => void
    tipo_aprobador: string,
    tipo_personal: string,

}





const ModalEnviarPlanificaciones: React.FC<Props_ModalEnviarPlanificaciones> = (props: Props_ModalEnviarPlanificaciones) => {


    const [loadingContenido, setloadingContenido] = useState<boolean>(false)
    const [confirmado, setconfirmado] = useState<boolean>(false)
    const [tipo_aprobador, settipo_aprobador] = useState<string>("")
    const [accion_realizar, setaccion_realizar] = useState<string>("")
    const [aceptar, setaceptar] = useState<number>(-1)

    const [erroresEnviarDirectivo, seterroresEnviarDirectivo] = useState<Array<string>>([])


    const cerrar_modal = () => {
        setconfirmado(false)
        setaceptar(-1)
        setloadingContenido(false)
        props.toogle();
    }

    useEffect(() => {
        if (props.tipo_aprobador !== "") {
            settipo_aprobador(tipo_aprobador);
            var accion: string = "";
            if (props.tipo_aprobador === PRIMER_APROBADOR) {
                accion = "enviar las planificaciones al directivo"
            }
            else if (props.tipo_aprobador === SEGUNDO_APROBADOR) {
                accion = "aprobar todas las planificaciones con estado parcialmente aprobadas"
            }
            setaccion_realizar(accion);

        }
    }, [props.tipo_aprobador])

    useEffect(() => {

        const handleEnviarDirectivo = async (tipo_aprobador: string) => {
            const ERROR_ENVIAR_DIRECTIVO = "NO HAY PLANIFICACIONES QUE SE PUEDAN APROBAR"
            setloadingContenido(true);
            var currentUser = authenticationService.currentUserValue;


            var estado_enviar = ""
            if (tipo_aprobador === PRIMER_APROBADOR) {
                estado_enviar = ESTADO_APROBACION_PARCIAL
            }
            else if (tipo_aprobador === SEGUNDO_APROBADOR) {
                estado_enviar = ESTADO_APROBADO
            }

            var RequestEnviarPlanificacionesDTO:RequestEnviarTalentoHumano = {estado:estado_enviar};


            try {
                const respuesta_request = await axios.post(configData.SERVER_URL + `PlanificacionVacaciones/Directivo/AprobarEnviarTodas/${props.tipo_personal}`, RequestEnviarPlanificacionesDTO,
                    {
                        headers: {

                            'Content-Type': 'application/json',
                            Authorization: `KEYESPOL ${currentUser?.token}`
                        }
                    });

                var personas_modificadas: Array<number> = respuesta_request.data;
                window.location.reload();

            } catch (error) {
                var error_any: any = error
                var status_error = handle_error(error_any);
                var errores_response: Array<string> = ["Ha ocurrido un inconveniente"];
                switch (status_error) {
                    case 415:
                        errores_response.push("La información que ha enviado no es válida")
                        break;

                    case 401:
                        errores_response.push("No está autorizado a realizar está acción")
                        break;

                    case 400:
                        
                        if (error_any.response !== undefined && error_any.response.data.errors.Planificacion_Vacaciones) {
                            errores_response.push("El periodo de planificación aún no comienza o ha terminado");
                        }
                        else {
                            errores_response.push("La información que ha enviado no es válida")
                            
                        }
                        break;
                    case 409:
                        if (error_any.response && error_any.response.data === ERROR_ENVIAR_DIRECTIVO && props.tipo_aprobador === PRIMER_APROBADOR)
                            errores_response.push("Sus planificaciones ya se enviaron al segundo Aprobador")
                        else if (error_any.response && error_any.response.data === ERROR_ENVIAR_DIRECTIVO && props.tipo_aprobador === SEGUNDO_APROBADOR)
                            // errores_response.push("Debe esperar a que el primer directivo termine de aprobar las planificaciones o Es probable que las planificaciones ya se aprobaron en su totalidad")
                            errores_response.push("Es probable que las planificaciones ya se aprobaron en su totalidad")

                        break;
                    default:
                        errores_response.push("No es posible contactar con el servidor")
                        break;
                }
                seterroresEnviarDirectivo(errores_response);


            }
            setconfirmado(true);
            setloadingContenido(false)
        }


        if (aceptar > -1 && props.tipo_aprobador !== "") {
            handleEnviarDirectivo(props.tipo_aprobador)
        }


    }, [aceptar])

    const handlevalorenviar = (valor: number) => {
        return valor + 1;
    }




    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={"md"}
            fullscreen={"md"}
            centered={true}
            onClosed={props.onClose}
        >
            <ModalHeader close={<button onClick={() => cerrar_modal()} >x</button>} />
            <ModalBody>
                <div className="titulo_modal_enviar_planificaciones">Confirmación acción  </div>
                {
                    loadingContenido && <Cargando />
                }

                {!loadingContenido && !confirmado && props.tipo_aprobador != "" &&
                    <React.Fragment>
                        <Row>
                            <Col xl={12}>
                                <div className="texto_modal_enviar_planificaciones">¿Estás seguro que deseas  {accion_realizar} ?</div>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col xl={6} md={6} sm={12} className="text-md-right text-center text-center ">
                                <div className="container_botones">
                                    <button className="btnAprobarPlanificacion" onClick={() => setaceptar(handlevalorenviar(1))}> Aceptar</button>
                                </div>

                            </Col>
                            <Col xl={6} md={6} sm={12} className="text-md-left text-lg-left text-center mt-1 mt-sm-1 mt-md-0 " >
                                <div className="container_botones">
                                    <button className="btnRechazarPlanificacion" onClick={() => cerrar_modal()}> Cancelar </button>
                                </div>

                            </Col>
                        </Row>
                    </React.Fragment>

                }

                {
                    props.tipo_aprobador === PRIMER_APROBADOR && confirmado &&
                    <React.Fragment>
                        <Col xl={10} lg={8} className="col_mensajesEnviarDirectivo ">
                            {!loadingContenido && aceptar && erroresEnviarDirectivo.length != 0 &&
                                erroresEnviarDirectivo.map((texto_errores, index_error_directivo) => {
                                    return (
                                        <React.Fragment key={"error_enviar_Directivo " + index_error_directivo}>
                                            <small className="erroresEnviarDirectivo mt-1 text-center">
                                                {`${index_error_directivo == 0 ? "" : index_error_directivo + ")"} ${texto_errores}`}
                                            </small>
                                            <br />

                                        </React.Fragment>
                                    )

                                })
                            }
                            {!loadingContenido && aceptar && erroresEnviarDirectivo.length != 0 &&

                                <div className="container_botones text-center">
                                    <button className="btnRechazarPlanificacion" onClick={() => cerrar_modal()}> Cancelar </button>
                                </div>


                            }
                            {!loadingContenido && aceptar && erroresEnviarDirectivo.length == 0 &&
                                <React.Fragment>
                                    <Row className="justify-content-center">
                                        <Col className="text-center">
                                            <small className="">{"Todas las planificaciones se encuentran parcialmente aprobadas.Comunique a su directivo. Espere un momento por favor ..."}</small>

                                        </Col>

                                    </Row>

                                </React.Fragment>

                            }
                        </Col>
                    </React.Fragment>
                }



                {
                    props.tipo_aprobador === SEGUNDO_APROBADOR && confirmado &&
                    <React.Fragment>
                        <Col xl={10} lg={8} className="col_mensajesEnviarDirectivo ">
                            {loadingContenido && <Cargando />}
                            {!loadingContenido && aceptar && erroresEnviarDirectivo.length != 0 &&
                                erroresEnviarDirectivo.map((texto_errores, index_error_directivo) => {
                                    return (
                                        <React.Fragment key={"error_enviar_Directivo " + index_error_directivo}>

                                            <small className="erroresEnviarDirectivo mt-1">
                                                {`${index_error_directivo == 0 ? "" : index_error_directivo} ${texto_errores}`}
                                            </small>
                                            <br />


                                        </React.Fragment>
                                    )
                                })
                            }
                            {!loadingContenido && aceptar && erroresEnviarDirectivo.length == 0 &&
                                <React.Fragment>
                                    <Row>
                                        <Col>
                                            <small className="text-center">{"Todas las planificaciones parcialmente aprobadas ahora están aprobadas en su totalidad"}</small>

                                        </Col>

                                    </Row>
                                    {/* <Row>
                                        <Col>
                                        <button onClick={() => window.location.reload()}>Continuar</button>

                                        </Col>

                                    </Row> */}
                                </React.Fragment>
                            }
                        </Col>
                    </React.Fragment>
                }

            </ModalBody>
        </Modal>
    )
}
export default ModalEnviarPlanificaciones;
